<h2 mat-dialog-title>Simulación de Prorrateo de Expensas</h2>

<div mat-dialog-content>

  <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column" *ngIf="input != null && input?.UfsLiquidacion != null && input?.UfsLiquidacion.length > 0">

    <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center start" class="flex-item" style="margin: 10px 0px; font-size: 16px;">
      <mat-label style="font-weight: bold;">Período: {{input?.ExpensaPeriodo}}</mat-label>
    </div>
    <div fxFlex=50 fxFlex.xs=100 fxLayoutAlign="center start" class="flex-item" style="margin: 10px 0px; font-size: 16px;">
      <mat-label style="font-weight: bold;">Total a Liquidar en Gastos: ${{(input?.ExpensaTotal) | number:'1.2-2'}}</mat-label>
    </div>

    <div fxFlex=100 fxFlex.xs=100 class="flex-item">
      
      <ejs-grid #ufGrid [dataSource]='input?.UfsLiquidacion' [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [allowSorting]="false"
        [allowResizing]='true' (actionFailure)="onGridActionFailure($event)" [enablePersistence]="false" [allowKeyboard]="false" [allowPaging]="ufGridAllowPaging" 
        [pageSettings]='ufGridPageSettings'>
        <e-columns>
          <e-column field="UnidadFuncionalNumero" headerText='Nro. UF' width=65></e-column>
          <e-column headerText='Cód. UF' width=80></e-column>
          <e-column headerText='Tipo Unidad' width=110></e-column>

          <e-column field="SaldoAnterior" headerText='Saldo Ant.' textAlign='Right' width="100" *ngIf="ufLiquidaciones.HabilitarControlCaja"></e-column>
          <e-column field="PagosAnterior" headerText='Pagos Ant.' textAlign='Right' width="100" *ngIf="ufLiquidaciones.HabilitarControlCaja"></e-column>
          <e-column field="SaldoGeneral" headerText='Saldo Actual' textAlign='Right' width="100" *ngIf="ufLiquidaciones.HabilitarControlCaja"></e-column>
          <e-column field="Intereses" headerText='Interés' textAlign='Right' width="100" *ngIf="ufLiquidaciones.HabilitarControlCaja"></e-column>
                  
          <ng-container *ngFor="let gasto of input?.TiposGasto">
            <e-column field="Porcentaje-{{gasto?.TipoGastoId}}" headerText='% {{gasto?.TipoGasto}}' *ngIf="gasto?.MostrarEnResumenExpensa" textAlign='Right' width=80></e-column>
            <e-column field="Importe-{{gasto?.TipoGastoId}}" headerText='Gastos {{gasto?.TipoGasto}}' textAlign='Right' width=80></e-column>
          </ng-container>

          <e-column field="Redondeo1" headerText='Redondeo' textAlign='Right' width=55></e-column>
          <e-column *ngIf="showFondoOperativoColumn" field="FondoOperativo" headerText='Fondo Operativo' textAlign='Right' width="120"></e-column>
          <e-column field="TotalPrimerVencimiento" headerText='Total 1er. Venc.' textAlign='Right' width=90></e-column>
          <e-column field="TotalSegundoVencimiento" headerText='Total 2do. Venc.' textAlign='Right' width=90></e-column>
        </e-columns>
        
        <ng-template #rowTemplate let-data>
          <tr class="e-row">
            <td class="e-rowcell">{{data?.UnidadFuncionalNumero}}</td>
            <td class="e-rowcell">{{data?.UnidadFuncionalCodigo}}</td>
            <td class="e-rowcell">{{data?.UnidadFuncionalTipo}}</td>

            <td class="e-rowcell" align="right" *ngIf="ufLiquidaciones.HabilitarControlCaja">${{data.SaldoAnterior | number: '1.2-2'}}</td>
            <td class="e-rowcell" align="right" *ngIf="ufLiquidaciones.HabilitarControlCaja">${{data.PagosAnterior | number: '1.2-2'}}</td>
            <td class="e-rowcell" align="right" *ngIf="ufLiquidaciones.HabilitarControlCaja">${{data.SaldoGeneral | number: '1.2-2'}}</td>
            <td class="e-rowcell" align="right" *ngIf="ufLiquidaciones.HabilitarControlCaja">${{data.Intereses | number: '1.2-2'}}</td>

            <ng-container *ngFor="let valor of data?.Valores">
              <td class="e-rowcell" align="right" *ngIf="valor?.MostrarEnResumenExpensa">
                {{valor?.Porcentaje | number: '1.2-2'}}%
              </td>
              <td class="e-rowcell" align="right">
                ${{valor?.Importe | number: '1.2-2'}}
              </td>
            </ng-container>

            <td class="e-rowcell" align="right">${{data?.Redondeo1 | number: formatRedondeo()}}</td>
            <td class="e-rowcell" align="right" *ngIf="showFondoOperativoColumn">${{data?.FondoOperativo | number: '1.2-2'}}</td>
            <td class="e-rowcell" align="right">${{data?.TotalPrimerVencimiento | number: '1.2-2'}}</td>
            <td class="e-rowcell" align="right">${{data?.TotalSegundoVencimiento | number: '1.2-2'}}</td>
          </tr>
        </ng-template>
      
        <e-aggregates>
          <e-aggregate>
            <e-columns>
              <e-column field="UnidadFuncionalNumero" type="count">
                <ng-template #footerTemplate let-data>Cantidad: {{data?.count}}</ng-template>
              </e-column>

              <e-column field="SaldoAnterior" type="sum" textAlign='Right' *ngIf="ufLiquidaciones.HabilitarControlCaja">
                <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                  <ng-template #footerTemplate let-data>${{data.sum | number:'1.2-2'}}</ng-template>
                </mat-label>
              </e-column>
              <e-column field="PagosAnterior" type="sum" textAlign='Right' *ngIf="ufLiquidaciones.HabilitarControlCaja">
                <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                  <ng-template #footerTemplate let-data>${{data.sum | number:'1.2-2'}}</ng-template>
                </mat-label>
              </e-column>
              <e-column field="SaldoGeneral" type="sum" textAlign='Right' *ngIf="ufLiquidaciones.HabilitarControlCaja">
                <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                  <ng-template #footerTemplate let-data>${{data.sum | number:'1.2-2'}}</ng-template>
                </mat-label>
              </e-column>
              <e-column field="Intereses" type="sum" textAlign='Right' *ngIf="ufLiquidaciones.HabilitarControlCaja">
                <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                  <ng-template #footerTemplate let-data>${{data.sum | number:'1.2-2'}}</ng-template>
                </mat-label>
              </e-column>

              <ng-container *ngFor="let gasto of input?.TiposGasto">
                <e-column field="Porcentaje-{{gasto?.TipoGastoId}}" type="Custom" textAlign='Right' *ngIf="gasto?.MostrarEnResumenExpensa">
                  <ng-template #footerTemplate let-data>{{sumUfPorcentaje(gasto.TipoGastoId) | number:'1.2-2'}}%</ng-template>
                </e-column>
                <e-column field="Importe-{{gasto?.TipoGastoId}}" type="Custom" textAlign='Right'>
                  <ng-template #footerTemplate let-data>${{sumUfImporte(gasto.TipoGastoId) | number:'1.2-2'}}</ng-template>
                </e-column>
              </ng-container>

              <e-column field="Redondeo1" type="sum" textAlign='Right'>
                <ng-template #footerTemplate let-data>
                  <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                    ${{data?.sum | number: formatRedondeo()}}
                  </mat-label>
                </ng-template>
              </e-column>
              <e-column field="FondoOperativo" type="sum" textAlign='Right' *ngIf="showFondoOperativoColumn">
                <ng-template #footerTemplate let-data>
                  <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                    ${{data?.sum | number:'1.2-2'}}
                  </mat-label>
                </ng-template>
              </e-column>
              <e-column field="TotalPrimerVencimiento" type="sum" textAlign='Right'>
                <ng-template #footerTemplate let-data>
                  <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                    ${{data?.sum | number:'1.2-2'}}
                  </mat-label>
                </ng-template>
              </e-column>
              <e-column field="TotalSegundoVencimiento" type="sum" textAlign='Right'>
                <ng-template #footerTemplate let-data>
                  <mat-label style="text-align: right; float: right; padding-top: 0px !important;">
                    ${{data?.sum | number:'1.2-2'}}
                  </mat-label>
                </ng-template>
              </e-column>
            </e-columns>
          </e-aggregate>
        </e-aggregates>

      </ejs-grid>

    </div>

  </div>

  <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="input.HayUfsSinCubrirTotal" style="margin-bottom: 15px;">
    <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="border-radius: 10px; background-color: lightblue; padding-bottom: 15px;">
      <mat-label style="font-weight: bold; text-align: center; padding-top: 15px;">
        <u>NOTA:</u> hay porcentajes de unidades funcionales que no suman el 100% de prorrateo para los gastos.
      </mat-label>
    </div>
  </div>

</div>

<br/>

<div mat-dialog-actions>
  <div fxLayout="row stretch" fxLayout.xs="column">
    <button mat-raised-button (click)="pageUfGrid()" class="zb-button">
      {{ufGridAllowPaging ? 'Ver Completo' : 'Ver Paginado'}}
    </button>
    <button mat-raised-button color="warn" (click)="onCancel()" class="zb-button">Cerrar</button>
  </div>
</div>